module.exports = __webpack_public_path__ + "static/media/studio-4.e064d090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/studio-4.jpg
// module id = 1663
// module chunks = 0